/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {MapLegendComponent} from './map-legend.component';
import {NgModule} from '@angular/core';
import {SharedModule} from '../../shared/shared.module';
import {RedlineIconComponent} from './redline-icon.component';
import { MapLegendContainerComponent } from './map-legend-container.component';
import { MapLegendTreeComponent } from './map-legend-tree.component';

@NgModule({
    declarations: [
        MapLegendComponent,
        RedlineIconComponent,
        MapLegendContainerComponent,
        MapLegendTreeComponent,
    ],
    exports: [
        MapLegendComponent,
    ],
    imports: [
        SharedModule,
    ],
    providers: []
})
export class MapLegendModule {
}
